
export default {
   props: {
    menuOpen: {
      type: Boolean,
      default: false,
    },
  },
};
